import { useQuery } from '@tanstack/react-query';
import type { RelatedType } from '@platform/shared';
import { api } from '../../api/client';

export const relatedKey = (type: RelatedType, id: string) => ['related', type, id] as const;

/** The rail's projection (`GET /api/related/:type/:id`), shared by the rail and the list filter opened from its *All N →*. */
export function useRelated(type: RelatedType, id: string) {
  return useQuery({ queryKey: relatedKey(type, id), queryFn: () => api.related(type, id), enabled: id !== '', staleTime: 60_000 });
}
